/**
 * "MASTERCARD" + "BLACK" → "Mastercard Black".
 *
 * A bandeira e o nível chegam do Open Finance como códigos em maiúsculas. Os
 * nomes conhecidos têm a grafia da própria marca; o que não está na lista é
 * só posto em caixa de título, para um nível novo aparecer legível em vez de
 * sumir.
 *
 * Puro.
 */
const MARCAS: Record<string, string> = {
  MASTERCARD: 'Mastercard', VISA: 'Visa', ELO: 'Elo', AMEX: 'American Express',
  AMERICAN_EXPRESS: 'American Express', 'AMERICAN EXPRESS': 'American Express',
  HIPERCARD: 'Hipercard', DINERS: 'Diners Club', 'DINERS CLUB': 'Diners Club',
};

const NIVEIS: Record<string, string> = {
  BLACK: 'Black', PLATINUM: 'Platinum', GOLD: 'Gold', INFINITE: 'Infinite', SIGNATURE: 'Signature',
  CLASSIC: 'Classic', STANDARD: 'Standard', INTERNATIONAL: 'Internacional', INTERNACIONAL: 'Internacional',
  NANQUIM: 'Nanquim', GRAFITE: 'Grafite', MAIS: 'Mais', BASIC: 'Básico',
};

const emTitulo = (codigo: string): string =>
  codigo.toLowerCase().replace(/_/g, ' ').replace(/(^|\s)\S/g, l => l.toUpperCase());

export const nomeDoCartao = (bandeira?: string | null, nivel?: string | null): string | null => {
  const b = (bandeira ?? '').trim().toUpperCase();
  const n = (nivel ?? '').trim().toUpperCase();
  const partes = [b ? (MARCAS[b] ?? emTitulo(b)) : '', n ? (NIVEIS[n] ?? emTitulo(n)) : ''].filter(Boolean);
  return partes.length > 0 ? partes.join(' ') : null;
};
